import RoutesMap from "route_control/RouteControl"
import { CountryList, StateList, CityList, ChargesTypeList, Charges, ChecklistList, ServiceTypeList, ServiceSubTypeList, DeliveryPartnerList, ExpenseTypeList, NoticeTypeList } from "pages/master"

const MasterRoute = () => {
    return [
        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },

        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },

        {
            path: RoutesMap.CITY_LIST.path,
            element: <CityList />
        },

        {
            path: RoutesMap.CHARGES_TYPE_LIST.path,
            element: <ChargesTypeList />
        },

        {
            path: RoutesMap.CHARGES.path,
            element: <Charges />
        },

        {
            path: RoutesMap.CHECKLIST_LIST.path,
            element: <ChecklistList />
        },

        {
            path: RoutesMap.SERVICE_TYPE_LIST.path,
            element: <ServiceTypeList />
        },

        {
            path: RoutesMap.SERVICE_SUB_TYPE_LIST.path,
            element: <ServiceSubTypeList />
        },

        {
            path: RoutesMap.DELIVERY_PARTNER_LIST.path,
            element: <DeliveryPartnerList />
        },

        {
            path: RoutesMap.EXPENSE_TYPE_LIST.path,
            element: <ExpenseTypeList />
        },

        {
            path: RoutesMap.NOTICE_TYPE_LIST.path,
            element: <NoticeTypeList />
        },
    ]
}

export default MasterRoute;